var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c3aec;\n      }\n\n      .cls-2 {\n        fill: #fefefe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.29,98.86l-72.25.07c-3.76,0-9.24-3.74-9.24-7.63l-.02-76.63c.09-2.72,4.88-5.88,7.23-6.66l70.75-.03c1.42-.65,4.64-1.25,6.03-.52,4.9,2.58,7.33,8.87,7.31,14.5l-.25,66.62c-.02,4.68-4.24,10.27-9.57,10.27ZM61.04,81.55l-.07-20.53,20.55-.14c.45-6,.5-10.15.23-15.73l-20.72.04-.15-20.98h-15.75s-.17,20.98-.17,20.98l-20.81-.03-.04,15.73,20.87.12.15,20.84c5.93.14,10.76.1,15.93-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.04,81.55c-5.16.41-9.99.45-15.93.32l-.15-20.84-20.87-.12.04-15.73,20.81.03.17-21h15.75s.15,21,.15,21l20.72-.04c.27,5.58.22,9.72-.23,15.73l-20.55.14.07,20.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8d850a800f5d8713b3f38a7f4eff4e29.svg";
export { ForwardRef as ReactComponent };